import { CommonCancellationsCrumbs } from './breadcrumb';

export const CancellationAireCitizenshipLossSearchCrumbs = [
  ...CommonCancellationsCrumbs,
  {
    name: 'Ricerca Persona - Cancellazione AIRE per Perdita Cittadinanza Italiana',
    path: '/cancellazioni/cancellazioni-aire/perdita-cittadinanza',
  },
];

export const CancellationAireCitizenshipLossCrumbs = [
  ...CancellationAireCitizenshipLossSearchCrumbs,
  {
    name: 'Cancellazione AIRE per Perdita Cittadinanza',
    path: '/cancellazioni/cancellazioni-aire/perdita-cittadinanza/cancellazione',
  },
];
